import R from 'ramda';

import { createAction } from 'ha/myredux/createAction';
import { setRemarketingTag } from 'ha/modules/Analytics/actions';
import { LocaleToCanonicalCollections } from 'ha/constants/SearchPageCollections';

import { Actions, PageType } from '../constants';
import {
  getMap,
  getSearchCollectionFilters,
  getSearchParams,
  getDateFilter,
  getCityCanonical,
  getCountryCode,
} from '../selectors';

const changeFilters = createAction(
  Actions.CHANGE_FILTERS,
  R.identity,
  ({ queryParams, pathname }) => ({
    queryParams,
    pathname,
    mergeQueryParams: true,
  }),
);

const categorySlug = (lang, type) => LocaleToCanonicalCollections[lang][type];

export const trackFiltersUpdate = ({ categories, startDate, endDate }) => (
  dispatch,
  getState,
) => {
  const state = getState();
  const cityCanonical = getCityCanonical(state);
  const countryCode = getCountryCode(state);
  const { categories: prevCategories } = getSearchParams(state);
  const { endDate: prevEndDate, startDate: prevStartDate } = getDateFilter(
    state,
  );

  const categoriesChanged = !R.equals(prevCategories, categories);
  const datesChanges =
    (startDate !== undefined || endDate !== undefined) &&
    !(startDate === prevStartDate && endDate === prevEndDate);

  if (categoriesChanged || datesChanges) {
    dispatch(
      setRemarketingTag(
        {
          hrental_pagetype: PageType,
          hrental_city: cityCanonical,
          hrental_country: countryCode,
          hrental_startdate: datesChanges ? startDate : prevStartDate,
          hrental_enddate: datesChanges ? endDate : prevEndDate,
          hrental_search_category: categoriesChanged
            ? categories
            : prevCategories,
        },
        { nonInteraction: 0 },
      ),
    );
  }
};

const onChangeFilters = ({
  price,
  types,
  registration,
  rules,
  recentlyAdded,
  furniture,
  bills,
  rooms,
  dates,
  gender,
  suitableFor,
  intl,
  // eslint-disable-next-line max-statements
}) => (dispatch, getState) => {
  const state = getState();

  const filters = { queryParams: { page: null, openMap: null } };

  // FIXME: probably could be removed completely, need to test properly after
  // Retrieve parameters from collection.
  Object.assign(filters.queryParams, getSearchCollectionFilters(state));

  if (types) {
    const { urlResolver, lang } = intl;
    const { location } = getMap(state);
    const urlBase = `/s/${location}`;
    const url =
      types.length === 1
        ? `${urlBase}/${categorySlug(lang, types[0])}`
        : urlBase;
    const pathname = urlResolver.formatHrefURL(url);

    Object.assign(filters, { pathname });
    Object.assign(filters.queryParams, { categories: types });
  }

  if (furniture !== undefined) {
    Object.assign(filters.queryParams, { furniture });
  }

  if (bills !== undefined) {
    Object.assign(filters.queryParams, { bills });
  }

  if (registration !== undefined) {
    Object.assign(filters.queryParams, { registration });
  }

  if (recentlyAdded !== undefined) {
    Object.assign(filters.queryParams, { recentlyAdded });
  }

  if (suitableFor) {
    Object.assign(filters.queryParams, { suitableFor });
  }

  if (rules) {
    Object.assign(filters.queryParams, { rules });
  }

  if (gender) {
    Object.assign(filters.queryParams, { gender });
  }

  if (rooms) {
    Object.keys(rooms).forEach(key =>
      Object.assign(filters.queryParams, {
        [key]: rooms[key] > 0 ? rooms[key] : null,
      }),
    );
  }

  if (price) {
    Object.assign(filters.queryParams, {
      currency: price.currency,
      priceMin: price.min,
      priceMax: price.max,
    });
  }

  if (dates) {
    Object.assign(filters.queryParams, dates);
  }

  dispatch(trackFiltersUpdate(filters.queryParams));

  // Normalize filters that don't need a query string.
  filters.queryParams.categories =
    filters.queryParams.categories && filters.queryParams.categories.length > 1
      ? filters.queryParams.categories
      : undefined;

  filters.queryParams.currency =
    filters.queryParams.currency !== 'EUR'
      ? filters.queryParams.currency
      : undefined;

  dispatch(changeFilters(filters));
};

export default onChangeFilters;
